import React, { useEffect } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { TextArea } from "../../../Component/TextArea";
import classes from "./Step3.module.css";

const Step3 = ({ text, setText }) => {

  useEffect(() => {
    if (text?.split(" ").filter((item) => item != "")?.length == 5) {
      setText((prev) => prev.slice(0, -1));
    }
  }, [text]);

  return (
    <Row>
      <Col>
        <h3>
          Description ({text?.split(" ").filter((item) => item != "")?.length})
        </h3>
        <div className={classes.text_div}>
          <TextArea
            customStyle={{ color: "#7B7B7B", borderColor: "#00000029" }}
            value={text}
            setter={(e) => {
              if (text?.split(" ").filter((item) => item != "")?.length < 5) {
                return setText(e);
              }
            }}
            rows={8}
            // onKeyUp={(e) => {
            //   if (
            //     e?.code == "Backspace" &&
            //     text?.split(" ").filter((item) => item != "")?.length == 5
            //   )
            //     setText((prev) => prev.slice(0, -1));
            // }}
          />
        </div>
      </Col>
    </Row>
  );
};

export default Step3;
